import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

gsap.defaults({
    ease: "ease",
    duration: 1,
});

gsap.config({
    nullTargetWarn: true,
    autoSleep: 60,
    force3D: false,
});

import { init } from "./init-scripts";
function safeInit() {
    requestAnimationFrame(() => setTimeout(init, 1));
}

if (document.readyState !== "loading") safeInit();
else document.addEventListener("DOMContentLoaded", safeInit);
